import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { ParameterInputType } from "@/types/parameterTypes";
import { Parameter } from "@/backend/models/parameter";
import { Dropdown } from "react-bootstrap";

export function ChangeInputTypeItem(props: { parameter: Parameter}) {
  const { parameter } = props;
  const updateParameter = useParameterStore(state => state.updateParameter);

  const updateInputType = async (inputType: ParameterInputType) => {
   void updateParameter({ parameter: { ...parameter, inputType, viewOnly: false } });
  };

  if (parameter.inputType === ParameterInputType.MULTIPLE_CHOICE) {
    return (
      <Dropdown.Item onClick={() => void updateInputType(ParameterInputType.LIST)}>
        {I18n.get('updateToList')}
      </Dropdown.Item>
    );
  }

  if (parameter.inputType === ParameterInputType.LIST) {
    return (
      <Dropdown.Item onClick={() => void updateInputType(ParameterInputType.MULTIPLE_CHOICE)}>
        {I18n.get('updateToMultipleChoice')}
      </Dropdown.Item>
    );
  }

  return null;
}
